import { oneOf } from 'prop-types'

export default oneOf(['generations', 'familylines'])
